module.exports = __webpack_public_path__ + "media/images/regions/causal_graphs/south_asia-a4a738db048a2029b9231cc4bb00bf71.svg";